import Icon from '../../common/Icon'
import Loading from '../../common/Loading'
import Post from '../Post'
import { useTranslation } from '../../../lib/i18n'

export default function FeedOverlay({ isPrivate, hideMessage = false }) {
  const { t } = useTranslation()
  const dummyPost = {
    title: t('feedOverlay.privateContent.title'),
    edited: true,
    content_delta: {
      ops: [
        {
          insert: t('feedOverlay.privateContent.content'),
        },
      ],
    },
    created_at: '2021-03-01T00:00:00.000Z',
    updated_at: '2021-03-01T00:00:00.000Z',
    plain_text: t('feedOverlay.privateContent.plainText'),
    user: {
      slug: 'tony-stark',
      name: 'Tony Stark',
    },
    reply_count: 0,
    replies: [],
    type: 'Post',
    upvote_count: 12,
    user_has_upvoted: true,
  }

  return (
    <div className="relative">
      <div className="absolute top-0 left-0 z-10 bottom-48 w-full h-full bg-gray-100 bg-opacity-50 backdrop-filter backdrop-blur-sm" />
      {!hideMessage && (
        <div className="z-99 bg-white flex flex-col items-center rounded-xl px-6 py-12 absolute top-40 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl border-2 border-gray-100">
          <Icon name="lock" color="primary" />
          <h3 className="font-bold text-center">
            {isPrivate
              ? t('feedOverlay.overlay.privateTitle')
              : t('feedOverlay.overlay.membersOnlyTitle')}
          </h3>
          <p className="text-center text-sm">
            {t('feedOverlay.overlay.joinMessage')}
          </p>
        </div>
      )}
      {hideMessage && (
        <div className="z-99 flex flex-col items-center rounded-xl absolute top-40 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <Loading />
        </div>
      )}
      <Post post={dummyPost} archived hideAvatar collapsable={false} />
      <Post post={dummyPost} archived hideAvatar collapsable={false} />
    </div>
  )
}
